<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back"/>
			<img src="@/images/center_text2.png" class="per_right_1name"/>
		</div>
		<div class="per_right_2">
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="旧密码" prop="oldpass" class="pas_pass">
					<el-input type="password" v-model="ruleForm.oldpass" placeholder="请输入旧密码" autocomplete="off" clearable></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="pass" class="pas_pass">
					<el-input type="password" v-model="ruleForm.pass" placeholder="请输入新密码" autocomplete="off" clearable></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPass" class="pas_pass">
					<el-input type="password" v-model="ruleForm.checkPass" placeholder="请再次输入新密码" autocomplete="off" clearable></el-input>
				</el-form-item>
				<el-form-item class="per_save">
					<div class="feedback_button" @click="submitForm('ruleForm')">
						<img src="@/images/zy_button.png" class="feedback_back" />
						<span>保存</span>
					</div>
					<div class="feedback_button" @click="resetForm('ruleForm')">
						<img src="@/images/zy_button_cancel.png" class="feedback_back" />
						<span>取消</span>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import { updateUserPass } from "@/api/user.js"
	import { removeToken, removeStorageToken } from '@/utils/auth'
	export default {
		data() {
			var validatePass0 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请输入旧密码'));
				} else {
					callback();
				}
			};
			var validatePass = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请输入新密码'));
				} else {
					if(this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				ruleForm: {
					oldpass: '',
					pass: '',
					checkPass: '',
				},
				rules: {
					oldpass: [{
						validator: validatePass0,
						trigger: 'blur'
					}],
					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if(valid) {
						var data = {
							oldpassword: this.ruleForm.oldpass,
							password: this.ruleForm.pass,
						}
						updateUserPass(data).then(res => {
							if(res.code == 'OK') {
								this.$alert('修改成功，请重新登陆！', '提示', {
									confirmButtonText: '确定',
									type: 'warning'
								}).then(() => {
									removeToken();
									removeStorageToken();
									location.reload()
								}).catch(() => {
									removeToken();
									removeStorageToken();
									location.reload()
								})
							} else {
								this.$message({
									type: "error",
									message: res.msg
								})
							}
						})
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		},
	}
</script>

<style>

</style>